export default {
  paged: {
    select: 'id,locked,lastLogin,name,agentPlatformType,city,state,userId,countryId',
    searchSelect: ['name', 'city'],
    expand: {
      user: { select: 'id,fullName' },
      country: { select: 'id,name,code' },
    },
    orderBy: 'lastLogin desc',
  },
  itemDetail: {
    expand: {
      user: { select: 'id,fullName' },
      country: { select: 'id,name,code' },
      appClient: { select: 'applicationName' },
    },
  },
};
